// used in bugbug
const LEFT_SIDEBAR__DASHBOARD = "left-sidebar--dashboard";
const LEFT_SIDEBAR__ACTION_PLAN = "left-sidebar--plan-action";
const LEFT_SIDEBAR__PLANNING = "left-sidebar--planning";
const LEFT_SIDEBAR__PARAMETERS = "left-sidebar--sidebar-action--parameters";
const LEFT_SIDEBAR__CUSTOMER_INTERFACE =
  "left-sidebar--sidebar-action--customer-interface";
const PARAMETERS_SECTOR_INFORMATION__SECTOR_NAME =
  "parameters-sector-information--input--sector-name";
const LAYOUT_CONTENT_WITH_ACTIONS__CONFIRM_BUTTON =
  "layout-content-with-actions--button--confirm";
const SIMULATION_DROPDOWN = "simulation-dropdown";
const SIMULATION_DROPDOWN__CREATE_SIMULATION_BUTTON =
  "simulation-dropdown--button--create-simulation";
const SIMULATION_STEPPER_BTN = "simulation-stepper-btn";
const PARAMETERS_OPLIT_USERS__TABLE = "parameters-oplit-users--table";
const PARAMETERS_OPLIT_USERS__CREATE_BUTTON =
  "parameters-oplit-users--button--create-user";
const PARAMETERS_OPLIT_USERS__UPDATE_BUTTON =
  "parameters-oplit-users--button--update-user";
const PARAMETERS_OPLIT_USERS__DELETE_BUTTON =
  "parameters-oplit-users--button--delete-user";
const SIMULATION_WRAPPER__STEPPER_CONTENT_ACTIVE =
  "simulation-wrapper--stepper-content-active";
const SIMULATION__LOAD_EVENT_BUTTON = "simulation--button--load-event";
const RIGHT_SIDEBAR = "right-sidebar--planning";
const RIGHT_SIDE_FIELDS__FIELDS_WRAPPER = "right-side-fields--fields-wrapper";
const PLANNING_NODE_ASSIGNMENT_INPUT__INPUT =
  "planning-node-assignment-input--input";
const PLANNING_API__PLANNING_ROW = "planning-api--planning-row";
const PLANNING_NODE_WRAPPER__DELETE_BUTTON =
  "planning-node-wrapper--button--delete";
const PLANNING_CELL__ADD_WRAPPER_BUTTON = "planning-cell--button--add-wrapper";
const WRAPPER_SETTING__ACTIVATOR = "wrapper-setting--button--activator";
const WRAPPER_SETTING__PLANNING__CREATE_SIMULATION_BUTTON =
  "wrapper-setting--button--create-simulation--planning";
const WRAPPER_SETTING__PLANNING__UPDATE_SIMULATION_BUTTON =
  "wrapper-setting--button--update-simulation--planning";
const WRAPPER_SETTING__PLANNING__ARCHIVE_SIMULATION_BUTTON =
  "wrapper-setting--button--archive-simulation--planning";
const WRAPPER_SETTING__PLANNING__DELETE_SIMULATION_BUTTON =
  "wrapper-setting--button--delete-simulation--planning";
const WRAPPER_SETTING__SCHEDULING__UPDATE_CAPACITY_BUTTON =
  "wrapper-setting--button--update-capacity--scheduling";
const WRAPPER_SETTING__SCHEDULING__CREATE_SIMULATION_BUTTON =
  "wrapper-setting--button--create-simulation--scheduling";
const WRAPPER_SETTING__SCHEDULING__UPDATE_SIMULATION_BUTTON =
  "wrapper-setting--button--update-simulation--scheduling";
const WRAPPER_SETTING__SCHEDULING__DELETE_SIMULATION_BUTTON =
  "wrapper-setting--button--delete-simulation--scheduling";
const WRAPPER_SETTING__SCHEDULING__SEND_OPS_UPDATE_BUTTON =
  "wrapper-setting--button--send-ops-update--scheduling";
const DRAG_AND_DROP = "drag-and-drop";

const SIMULATION_FORM__TITLE = "simulation-form--title";
// FIXME: format properly after ensuring selector is not used in bugbug
const SIMULATION_FORM__NAME_INPUT = "new-simulation-name";
const SIMULATION_FORM__STEP_DESCRIPTION = "simulation-form__step-description";
const SIMULATION_FORM__ONLY_ADMIN = "simulation-form__only-admin";
const SIMULATION_FORM__BACK_BUTTON = "simulation-form__back-button";
const SIMULATION_FORM__CANCEL_BUTTON = "simulation-form__cancel-button";
const SIMULATION_FORM__DATEPICKER = "simulation-form__datepicker";
const SIMULATION_FORM__NEXT_BUTTON = "simulation-form__next-button";
const SIMULATION_FORM__LOAD_TYPES_CHECKBOXES_CONTAINER =
  "simulation-form__load-types-checkboxes-container";
const SIMULATION_FORM__OFS_DROPDOWN = "simulation-form__ofs-dropdown";
const SIMULATION_FORM__OFS_DROPDOWN__ITEM_PREFIX =
  "simulation-form__ofs-dropdown__item-";
const SIMULATION_FORM__CUSTOMERS_ORDERS_DROPDOWN =
  "simulation-form__customers-orders-dropdown";
const SIMULATION_FORM__OFS_IMPORT_RADIO = "simulation-form__ofs-import-radio";
const SIMULATION_FORM__OFS_SCHEDULING_SIMULATION_RADIO =
  "simulation-form__ofs-scheduling-simulation-radio";
const SIMULATION_FORM__STOCK_DROPDOWN = "simulation-form__stock-dropdown";
const SIMULATION_FORM__STOCK_PF_DROPDOWN = "simulation-form__stock-pf-dropdown";
const SIMULATION_FORM__COMPONENTS_INITIAL_STOCK_DROPDOWN =
  "simulation-form__components-initial-stock-dropdown";
const SIMULATION_FORM__MERCA_ABSENCES_CHECKBOX =
  "simulation-form__merca-absences-checkbox";
const SIMULATION_FORM__IS_FLOATING_SIMULATION_CHECKBOX =
  "simulation-form__is-floating-simulation-checkbox";
const SIMULATION_FORM__DUPLICATE_EVENTS_FALSE_RADIO =
  "simulation-form__duplicate-events-false-radio";
const SIMULATION_FORM__DUPLICATE_EVENTS_LABEL =
  "simulation-form__duplicate-events-label";
const SIMULATION_FORM__STOCK_DROPDOWN__ITEM_PREFIX =
  "simulation-form__stock-dropdown__item-";
const SIMULATION_FORM__STOCK_PF_DROPDOWN__ITEM_PREFIX =
  "simulation-form__stock-pf-dropdown__item-";

const SECTOR_BREADCRUMBS__LEVEL_PREFIX = "sector-breadcrumbs--level--";
const SECTOR_BREADCRUMBS__CONTAINER = "sector-breadcrumbs__container";
const SIMULATION__CONTENT_TABS__PREFIX = "simulation--content-tabs--";
const FBUTTON__DEFAULT_DATA_TEST_ID = "fbutton--default-data-test-id";
const FBUTTON__DEFAULT_SLOT = "fbutton--default-slot";

const HOME_WELCOME__TITLE = "homepage-header-text";

const HOME_DISPLAY_MENU__PLANNING_SWITCH =
  "homepage-display-menu-switch-planning";
const HOME_DISPLAY_MENU__SCHEDULING_SWITCH =
  "homepage-display-menu-switch-scheduling";
const HOME_DISPLAY_MENU__PILOTING_SWITCH =
  "homepage-display-menu-switch-piloting";

const OPERATION_PRIORITY_CHIP__CHIP_PREFIX = "operation-priority-chip-";
const SCHEDULING_DISPLAY_MENU__MENU_BUTTON = "scheduling-display-menu-button";
const SCHEDULING_DISPLAY_MENU__WEEKEND_SWITCH =
  "scheduling-display-menu-switch-weekend";
const SCHEDULING_DISPLAY_MENU__SLIPPERY_SWITCH =
  "scheduling-display-menu-switch-slippery";
const SCHEDULING_DISPLAY_MENU__SYNTHETIC_SWITCH =
  "scheduling-display-menu-switch-synthetic";
const F_MAILLE_BUTTON__MESH_ITEM_PREFIX = "maille-button-";

const SCHEDULING_NEW_TAGS_MENU__ACTIVATOR =
  "scheduling-new-tags-menu__activator";
const SCHEDULING_NEW_TAGS_MENU__SEARCH_INPUT =
  "scheduling-new-tags-menu__search-input";
const SCHEDULING_NEW_TAGS_MENU__CONFIRM_BUTTON =
  "scheduling-new-tags-menu__confirm-button";

const LIST_OFS__CELL__TAGS_CONTAINER = "list-ofs__cell__tags-container";
const LIST_OFS__ADD_TAGS = "list-ofs__add-tags";
const LIST_OFS__ACTIONS_BUTTON = "list-ofs__actions-button";
const LIST_OFS__UPDATE_OPS = "list-ofs__update-ops";
const LIST_OFS__SELECT_CHECKBOX_PREFIX = "list-ofs__select-checkbox-";
const LIST_OFS__TABLE = "list-ofs__table";
const LIST_OFS__REF_ARTICLE = "list-ofs__ref-article";

const OPERATION_UPDATE_MODAL__PERIMETERS_DROPDOWN =
  "operation-update-modal__perimeters-dropdown";
const SCHEDULING_NEW_TAGS_MENU__TAGS_WRAPPER =
  "scheduling-new-tags-menu__tags-wrapper";

const OPERATIONS_RIGHT_BAR__CLOSE_ICON = "operations-right-bar__close-icon";

const FLUX_DATA_BODY__SECTORS_SELECTOR = "flux-data-body__sectors-selector";
const FLUX_DATA_BODY__STATUS_CHIP = "flux-data-body__status-chip";
const FLUX_DATA_BODY__OPERATION_DATE = "flux-data-body__operation-date";

const OPERATION_UPDATE_MODAL__STATUS_INPUT =
  "operation-update-modal__status-input";
const OPERATION_UPDATE_MODAL__STATUS_CHIP_PREFIX =
  "operation-update-modal__status-";

const FILTERS_DIALOG__TAGS_INPUT = "filters-dialog__tags-input";
const FILTERS_DIALOG__VALIDATE_BUTTON = "filters-dialog-validate-button";
const FILTERS_DIALOG__FILTERS_COUNT = "filters-dialog__filters-count";
const SCHEDULING_OFS__SEARCH_INPUT = "scheduling-ofs__search-input";
const SCHEDULING_OFS__PAGE_WRAPPER = "scheduling-ofs__page-wrapper";

const OPERATION_STATUS__ACTIVATOR_PREFIX = "operation-status__activator-";
const OPERATION_STATUS__STATUS_PREFIX = "operation-status-";

const PILOTING_EN_COURS__PRIORITIZATION__ACTIVATOR =
  "piloting-en-cours__prioritization__activator";
const PILOTING_EN_COURS__PRIORITIZATION__RULE_PREFIX =
  "piloting-en-cours__prioritization__rule-";
const PILOTING_EN_COURS__PRIORITIZATION__LIST_ITEM_PREFIX =
  "piloting-en-cours__prioritization__list-item-";
const PILOTING_EN_COURS__DISPLAY_MENU__ACTIVATOR =
  "piloting-en-cours__display-menu-activator";
const PILOTING_EN_COURS__SECONDARY_INFO_SWITCH =
  "piloting-en-cours__secondary-info-switch";
const PILOTING_EN_COURS__STAGNATION_SWITCH =
  "piloting-en-cours__stagnation-switch";
const PILOTING_EN_COURS__KPIS_SWITCH = "piloting-en-cours__kpis-switch";
const PILOTING_EN_COURS__STATUS_AUTOCOMPLETE =
  "piloting-en-cours__status-autocomplete";
const SCHEDULING_GROUP_BY_DROPDOWN__ACTIVATOR =
  "scheduling-group-by-menu__activator";
const SCHEDULING_COLORS_CATEGORY_DROPDOWN__ACTIVATOR =
  "scheduling-colors-category-menu__activator";
const PILOTING_EN_COURS__HORIZON_LIMIT_TOGGLE_SWITCH =
  "piloting-en-cours__horizon-limit__toggle-switch";
const PILOTING_EN_COURS__HORIZON_LIMIT_INPUT =
  "piloting-en-cours__horizon-limit__input";
const PILOTING_EN_COURS__VALIDATE_BUTTON = "piloting-en-cours__validate-button";
const PILOTING_EN_COURS__COLUMN__SECTOR = "piloting-en-cours__column-sector";
const PILOTING_EN_COURS__SEARCH_INPUT = "piloting-en-cours__search-input";

const OPERATIONS_RIGHT_BAR__DELAY_TEXT = "operations-right-bar__delay-text";

const DELAY_CHIP = "delay-chip";

const SCHEDULING_OPERATION_CARD__MAXIMIZE_ICON =
  "scheduling-operation-card__maximize-icon";

const GRAPH_SETTING__LIST_ITEM_PREFIX = "filter-list-";
const ENTITY_DETAILS_TOOLTIP__LABEL_PREFIX = "entity-details-tooltip__label-";

const PARAMETERS_SECTORS_GROUPS_MODAL__IS_PROTECTED_CONTAINER =
  "parameters-sectors-groups-modal__is-protected-container";
const PARAMETERS_SECTORS_GROUPS_MODAL__IS_CONWIP_CONTAINER =
  "parameters-sectors-groups-modal__is-conwip-container";
const PARAMETERS_SECTORS_GROUPS_MODAL__CONWIP_MAX_TICKETS_TEXTFIELD =
  "parameters-sectors-groups-modal__conwip-max-tickets-textfield";
const PARAMETERS_SECTORS_GROUPS_MODAL__HAS_MACHINES_WARNING =
  "parameters-sectors-groups-modal__has-machines";

const MINI_NUMBER_INPUT__INCREMENT_ICON = "mini-number-input__increment-icon";
const MINI_NUMBER_INPUT__DECREMENT_ICON = "mini-number-input__decrement-icon";

const CAPACITY_TABLE_ROW__CELL_PREFIX = "capacity-table-row__cell-";
const CAPACITY_TABLE_ROW__LOAD = "capacity-table-row__load";
const CAPACITY_TABLE_ROW__CAPACITY = "capacity-table-row__capacity";
const CAPACITY_TABLE_ROW__CHILDREN_SECTORS =
  "capacity-table-row__children-sectors";
const CAPACITY_TABLE_ROW__SECTOR_NAME_WRAPPER =
  "capacity-table-row__sector-name-wrapper";
const CAPACITY_TABLE_ROW__WRAPPER = "capacity-table-row__wrapper";
const KPIS_BANNER = "kpis-banner";
const KPIS_BANNER__ITEM_PREFIX = "kpis-banner__item__";
const ANALYTICS_CROSSING_TIMES_ARTICLE_TABLE_ROW__CELL_PREFIX =
  "analytics-crossing-times-article-table-row__cell__";
const ANALYTICS_CROSSING_TIMES_TABLE_ROW__CELL_PREFIX =
  "analytics-crossing-times-table-row__cell__";

const SEARCH_FIELD_INPUT__DROPDOWN = "search-field-input__dropdown";

const COMPARE_SIMULATIONS_MENU__SIMULATIONS_DROPDOWN =
  "compare-simulations-menu__simulations-dropdown";
const COMPARE_SIMULATIONS_MENU__CONFIRM_BUTTON =
  "compare-simulations-menu__confirm-button";
const COMPARE_SIMULATIONS_MENU__CLEAR_ICON =
  "compare-simulations-menu__clear-icon";

const GRAPH_CHARGE__LEGEND_ITEM = "legend-item-";

const SCHEDULING_OPERATIONS_CARDS_GROUP_WRAPPER__TOGGLE_ICON =
  "operations-cards-group-wrapper__toggle-icon";
const SCHEDULING_OPERATIONS_CARDS_GROUP_WRAPPER_PREFIX =
  "operations-cards-group-wrapper__";

const PRODUCTION_OBJECTIVE_DROPDOWN__TYPE_PREFIX =
  "production-objective-dropdown__type-";

const OPERATIONS_ACTIONS_MENU_STANDALONE_LEFT_ARROW =
  "operations-actions-menu-standalone__left-arrow";
const OPERATIONS_ACTIONS_MENU_STANDALONE_RIGHT_ARROW =
  "operations-actions-menu-standalone__right-arrow";

const FAVORITE_WRAPPER__ENTITY_PREFIX = "favorite-wrapper__entity-";

const OPERATION_COMPONENT_SHORTAGE = "operation-component-shortage";

const F_DROPDOWN_LIST__ITEM_PREFIX = "f-dropdown-list__item-";

const IMPORT_FILE__IMPORT_TYPES_DROPDOWN = "import-file__import-types-dropdown";
const IMPORT_FILE__DOWNLOAD_TEMPLATE_BUTTON =
  "import-file__download-template-button";

const F_SWITCH_BUTTON__SWITCH_ITEM_PREFIX = "switch-item-";

const GENERIC_BREADCRUMB__ITEM_PREFIX = "generic-breadcrumb__item-";

const EXPLAIN_MODAL__WRAPPER = "explain-modal__wrapper";
const EXPLAIN_MODAL__RESCHEDULING_CALL_DROPDOWN =
  "explain-modal__rescheduling-call-dropdown";

const SCHEDULING_COMPONENTS_COMPONENT_VIEW__BREADCRUMB =
  "scheduling-components-component-view__breadcrumb";
const PERIODS_PAGINATION__BUTTON_PREFIX = "periods-pagination__button-";
const COMMENTS_CHAT__MESSAGE_INPUT = "comments-chat__message-input";
const COMMENTS_CHAT__SEND_MESSAGE_BUTTON = "comments-chat__send-message-button";
const COMMENTS_CHAT__DELETE_ICON_PREFIX = "comments-chat__delete-icon-";

const SCHEDULING_CAPACITY__ROW_PREFIX = "scheduling-capacity__row-";

const AUTOMATIC_RESCHEDULING_MODAL__SECTORS_DROPDOWN =
  "rescheduling-sectors-selector";

const PARAMETERS_NOMENCLATURES__TABLE = "parameters-nomenclatures__table";

const PARAMETERS_STOCKS__ARTICLES_DROPDOWN =
  "parameters-stocks__articles-dropdown";

const F_DROPDOWN_LIST__SEARCH_INPUT = "f-dropdown-list__search-input";

const PARAMETERS_STOCKS__TABLE = "parameters-stocks__table";
const PARAMETERS_STOCKS__TABLE_ITEM_PREFIX = "parameters-stocks__table-item-";

const GAMMES_ROW__CELL_PREFIX = "gammes-row__cell-";

const STOCKS_PRODUCTS_ROW__ITEM_PREFIX = "stocks-products-row__item-";
const STOCKS_PRODUCTS_ROW__CELL_COVER = "stocks-products-row__cell-cover";
const STOCKS_PRODUCTS_ROW__SELECT_ICON = "stocks-products-row__select-icon";
const STOCKS_PRODUCTS_ROW__CELL_COVER_TOOLTIP =
  "stocks-products-row__cell-cover-tooltip";
const STOCKS_PRODUCTS_ROW__VIEW_DETAILS_ICON =
  "stocks-products-row__view-details-icon";
const STOCKS_PRODUCTS_ROW__SECTOR_REDIRECT =
  "stocks-products-row__sector-redirect";
const STOCKS_PRODUCTS_ROW__CELL_PREFIX = "stocks-products-row__cell-";

const PRODUCTION_OBJECTIVE_DROPDOWN__DROPDOWN =
  "production-objective-dropdown__dropdown";
const PRODUCTION_OBJECTIVE_DROPDOWN__INPUT =
  "production-objective-dropdown__input";
const PRODUCTION_OBJECTIVE_DROPDOWN__VALIDATE_ICON =
  "production-objective-dropdown__validate-icon";

const STOCKS_PRODUCT_ENTITY__LABEL = "stocks-product-entity__label";
const STOCKS_PRODUCT_ENTITY__MACHINE_LINK =
  "stocks-product-entity__machine-link";

const STOCKS_TABLE__SELECTED_HEADER = "stocks-table__selected-header";

const STOCKS_PRODUCT_ENTITY_PRODUCTION_PLAN_TABLE__OBJECTIVE_INPUT_PREFIX =
  "stocks-product-entity-production-plan-table__objective-input-";
const STOCKS_PRODUCT_ENTITY_PRODUCTION_PLAN_TABLE__STOCK_PREFIX =
  "stocks-product-entity-production-plan-table__stock-";

const LOAD_TABLE_ROW__EXPAND_ICON = "load-table-row__expand-icon";
const LOAD_TABLE_ROW__TOTAL_LOAD_CELL_VALUE =
  "load-table-row__total-load-cell-value";

const STOCKS_PRODUCTS__TITLE = "stocks-products__title";
const CAPA_IMPORT_MODAL__PLANNING_SIMULATION_SELECT =
  "capa-import-modal__planning-simulation-select";
const CAPA_IMPORT_MODAL__SCHEDULING_SIMULATION_SELECT =
  "capa-import-modal__scheduling-simulation-select";
const CAPA_IMPORT_MODAL__UPDATE_MODE_PREFIX = "capa-import-modal__update-mode-";

const FORM_SIMULATIONS_SELECT__DROPDOWN = "form-simulations-select";

const LOAD_TO_CAPACITY_BALANCE_DIALOG__ACTIVATOR =
  "load-to-capacity-balance-dialog__activator";
const LOAD_TO_CAPACITY_BALANCE_DIALOG__CONFIRM_BUTTON =
  "load-to-capacity-balance-dialog__confirm-button";

const SECTOR_CARD__STOCKS_REDIRECT = "sector-card__stocks-redirect";

export const TEST_IDS = {
  WRAPPER_SETTING__ACTIVATOR,
  LEFT_SIDEBAR__DASHBOARD,
  LEFT_SIDEBAR__ACTION_PLAN,
  LEFT_SIDEBAR__PARAMETERS,
  LEFT_SIDEBAR__PLANNING,
  LEFT_SIDEBAR__CUSTOMER_INTERFACE,
  PARAMETERS_SECTOR_INFORMATION__SECTOR_NAME,
  LAYOUT_CONTENT_WITH_ACTIONS__CONFIRM_BUTTON,
  SIMULATION_DROPDOWN,
  SIMULATION_DROPDOWN__CREATE_SIMULATION_BUTTON,
  SIMULATION_STEPPER_BTN,
  PARAMETERS_OPLIT_USERS__TABLE,
  PARAMETERS_OPLIT_USERS__CREATE_BUTTON,
  PARAMETERS_OPLIT_USERS__UPDATE_BUTTON,
  PARAMETERS_OPLIT_USERS__DELETE_BUTTON,
  SIMULATION_WRAPPER__STEPPER_CONTENT_ACTIVE,
  SIMULATION__LOAD_EVENT_BUTTON,
  RIGHT_SIDEBAR,
  RIGHT_SIDE_FIELDS__FIELDS_WRAPPER,
  PLANNING_NODE_ASSIGNMENT_INPUT__INPUT,
  PLANNING_API__PLANNING_ROW,
  SECTOR_BREADCRUMBS__LEVEL_PREFIX,
  SIMULATION__CONTENT_TABS__PREFIX,
  PLANNING_NODE_WRAPPER__DELETE_BUTTON,
  PLANNING_CELL__ADD_WRAPPER_BUTTON,
  WRAPPER_SETTING__PLANNING__CREATE_SIMULATION_BUTTON,
  WRAPPER_SETTING__PLANNING__UPDATE_SIMULATION_BUTTON,
  WRAPPER_SETTING__PLANNING__ARCHIVE_SIMULATION_BUTTON,
  WRAPPER_SETTING__PLANNING__DELETE_SIMULATION_BUTTON,
  WRAPPER_SETTING__SCHEDULING__UPDATE_CAPACITY_BUTTON,
  WRAPPER_SETTING__SCHEDULING__CREATE_SIMULATION_BUTTON,
  WRAPPER_SETTING__SCHEDULING__UPDATE_SIMULATION_BUTTON,
  WRAPPER_SETTING__SCHEDULING__DELETE_SIMULATION_BUTTON,
  WRAPPER_SETTING__SCHEDULING__SEND_OPS_UPDATE_BUTTON,
  DRAG_AND_DROP,
  SIMULATION_FORM__TITLE,
  SIMULATION_FORM__NAME_INPUT,
  FBUTTON__DEFAULT_DATA_TEST_ID,
  FBUTTON__DEFAULT_SLOT,
  HOME_WELCOME__TITLE,
  HOME_DISPLAY_MENU__PLANNING_SWITCH,
  HOME_DISPLAY_MENU__SCHEDULING_SWITCH,
  HOME_DISPLAY_MENU__PILOTING_SWITCH,
  OPERATION_PRIORITY_CHIP__CHIP_PREFIX,
  SCHEDULING_DISPLAY_MENU__MENU_BUTTON,
  SCHEDULING_DISPLAY_MENU__WEEKEND_SWITCH,
  SCHEDULING_DISPLAY_MENU__SLIPPERY_SWITCH,
  SCHEDULING_DISPLAY_MENU__SYNTHETIC_SWITCH,
  F_MAILLE_BUTTON__MESH_ITEM_PREFIX,
  SCHEDULING_NEW_TAGS_MENU__ACTIVATOR,
  SCHEDULING_NEW_TAGS_MENU__SEARCH_INPUT,
  SCHEDULING_NEW_TAGS_MENU__CONFIRM_BUTTON,
  LIST_OFS__CELL__TAGS_CONTAINER,
  LIST_OFS__ADD_TAGS,
  LIST_OFS__ACTIONS_BUTTON,
  LIST_OFS__UPDATE_OPS,
  LIST_OFS__SELECT_CHECKBOX_PREFIX,
  LIST_OFS__TABLE,
  LIST_OFS__REF_ARTICLE,
  OPERATION_UPDATE_MODAL__PERIMETERS_DROPDOWN,
  SCHEDULING_NEW_TAGS_MENU__TAGS_WRAPPER,
  OPERATIONS_RIGHT_BAR__CLOSE_ICON,
  FLUX_DATA_BODY__SECTORS_SELECTOR,
  FLUX_DATA_BODY__STATUS_CHIP,
  FLUX_DATA_BODY__OPERATION_DATE,
  OPERATION_UPDATE_MODAL__STATUS_INPUT,
  OPERATION_UPDATE_MODAL__STATUS_CHIP_PREFIX,
  FILTERS_DIALOG__TAGS_INPUT,
  FILTERS_DIALOG__VALIDATE_BUTTON,
  FILTERS_DIALOG__FILTERS_COUNT,
  SCHEDULING_OFS__SEARCH_INPUT,
  SCHEDULING_OFS__PAGE_WRAPPER,
  OPERATION_STATUS__ACTIVATOR_PREFIX,
  OPERATION_STATUS__STATUS_PREFIX,
  PILOTING_EN_COURS__PRIORITIZATION__ACTIVATOR,
  PILOTING_EN_COURS__PRIORITIZATION__RULE_PREFIX,
  PILOTING_EN_COURS__PRIORITIZATION__LIST_ITEM_PREFIX,
  PILOTING_EN_COURS__DISPLAY_MENU__ACTIVATOR,
  PILOTING_EN_COURS__SECONDARY_INFO_SWITCH,
  PILOTING_EN_COURS__STAGNATION_SWITCH,
  PILOTING_EN_COURS__KPIS_SWITCH,
  PILOTING_EN_COURS__STATUS_AUTOCOMPLETE,
  SCHEDULING_GROUP_BY_DROPDOWN__ACTIVATOR,
  SCHEDULING_COLORS_CATEGORY_DROPDOWN__ACTIVATOR,
  PILOTING_EN_COURS__HORIZON_LIMIT_TOGGLE_SWITCH,
  PILOTING_EN_COURS__HORIZON_LIMIT_INPUT,
  PILOTING_EN_COURS__VALIDATE_BUTTON,
  PILOTING_EN_COURS__COLUMN__SECTOR,
  OPERATIONS_RIGHT_BAR__DELAY_TEXT,
  DELAY_CHIP,
  SCHEDULING_OPERATION_CARD__MAXIMIZE_ICON,
  GRAPH_SETTING__LIST_ITEM_PREFIX,
  ENTITY_DETAILS_TOOLTIP__LABEL_PREFIX,
  PARAMETERS_SECTORS_GROUPS_MODAL__IS_PROTECTED_CONTAINER,
  PARAMETERS_SECTORS_GROUPS_MODAL__IS_CONWIP_CONTAINER,
  PARAMETERS_SECTORS_GROUPS_MODAL__CONWIP_MAX_TICKETS_TEXTFIELD,
  MINI_NUMBER_INPUT__INCREMENT_ICON,
  MINI_NUMBER_INPUT__DECREMENT_ICON,
  CAPACITY_TABLE_ROW__CELL_PREFIX,
  CAPACITY_TABLE_ROW__LOAD,
  CAPACITY_TABLE_ROW__CAPACITY,
  CAPACITY_TABLE_ROW__CHILDREN_SECTORS,
  CAPACITY_TABLE_ROW__SECTOR_NAME_WRAPPER,
  CAPACITY_TABLE_ROW__WRAPPER,
  KPIS_BANNER,
  KPIS_BANNER__ITEM_PREFIX,
  ANALYTICS_CROSSING_TIMES_ARTICLE_TABLE_ROW__CELL_PREFIX,
  ANALYTICS_CROSSING_TIMES_TABLE_ROW__CELL_PREFIX,
  SEARCH_FIELD_INPUT__DROPDOWN,
  COMPARE_SIMULATIONS_MENU__SIMULATIONS_DROPDOWN,
  COMPARE_SIMULATIONS_MENU__CONFIRM_BUTTON,
  COMPARE_SIMULATIONS_MENU__CLEAR_ICON,
  GRAPH_CHARGE__LEGEND_ITEM,
  SCHEDULING_OPERATIONS_CARDS_GROUP_WRAPPER__TOGGLE_ICON,
  SCHEDULING_OPERATIONS_CARDS_GROUP_WRAPPER_PREFIX,
  PRODUCTION_OBJECTIVE_DROPDOWN__TYPE_PREFIX,
  PARAMETERS_SECTORS_GROUPS_MODAL__HAS_MACHINES_WARNING,
  OPERATIONS_ACTIONS_MENU_STANDALONE_LEFT_ARROW,
  OPERATIONS_ACTIONS_MENU_STANDALONE_RIGHT_ARROW,
  FAVORITE_WRAPPER__ENTITY_PREFIX,
  SIMULATION_FORM__STEP_DESCRIPTION,
  SIMULATION_FORM__ONLY_ADMIN,
  SIMULATION_FORM__BACK_BUTTON,
  SIMULATION_FORM__DATEPICKER,
  SIMULATION_FORM__NEXT_BUTTON,
  SIMULATION_FORM__LOAD_TYPES_CHECKBOXES_CONTAINER,
  SIMULATION_FORM__OFS_DROPDOWN,
  SIMULATION_FORM__CUSTOMERS_ORDERS_DROPDOWN,
  SIMULATION_FORM__OFS_SCHEDULING_SIMULATION_RADIO,
  SIMULATION_FORM__STOCK_DROPDOWN,
  SIMULATION_FORM__STOCK_PF_DROPDOWN,
  SIMULATION_FORM__COMPONENTS_INITIAL_STOCK_DROPDOWN,
  SIMULATION_FORM__MERCA_ABSENCES_CHECKBOX,
  SIMULATION_FORM__IS_FLOATING_SIMULATION_CHECKBOX,
  SIMULATION_FORM__DUPLICATE_EVENTS_FALSE_RADIO,
  SIMULATION_FORM__OFS_IMPORT_RADIO,
  SIMULATION_FORM__CANCEL_BUTTON,
  SIMULATION_FORM__DUPLICATE_EVENTS_LABEL,
  SIMULATION_FORM__OFS_DROPDOWN__ITEM_PREFIX,
  OPERATION_COMPONENT_SHORTAGE,
  F_DROPDOWN_LIST__ITEM_PREFIX,
  IMPORT_FILE__IMPORT_TYPES_DROPDOWN,
  F_SWITCH_BUTTON__SWITCH_ITEM_PREFIX,
  GENERIC_BREADCRUMB__ITEM_PREFIX,
  EXPLAIN_MODAL__WRAPPER,
  EXPLAIN_MODAL__RESCHEDULING_CALL_DROPDOWN,
  SCHEDULING_COMPONENTS_COMPONENT_VIEW__BREADCRUMB,
  PERIODS_PAGINATION__BUTTON_PREFIX,
  COMMENTS_CHAT__MESSAGE_INPUT,
  COMMENTS_CHAT__SEND_MESSAGE_BUTTON,
  COMMENTS_CHAT__DELETE_ICON_PREFIX,
  SCHEDULING_CAPACITY__ROW_PREFIX,
  PILOTING_EN_COURS__SEARCH_INPUT,
  AUTOMATIC_RESCHEDULING_MODAL__SECTORS_DROPDOWN,
  IMPORT_FILE__DOWNLOAD_TEMPLATE_BUTTON,
  PARAMETERS_NOMENCLATURES__TABLE,
  PARAMETERS_STOCKS__ARTICLES_DROPDOWN,
  F_DROPDOWN_LIST__SEARCH_INPUT,
  PARAMETERS_STOCKS__TABLE,
  PARAMETERS_STOCKS__TABLE_ITEM_PREFIX,
  GAMMES_ROW__CELL_PREFIX,
  STOCKS_PRODUCTS_ROW__ITEM_PREFIX,
  SIMULATION_FORM__STOCK_DROPDOWN__ITEM_PREFIX,
  SIMULATION_FORM__STOCK_PF_DROPDOWN__ITEM_PREFIX,
  PRODUCTION_OBJECTIVE_DROPDOWN__DROPDOWN,
  STOCKS_PRODUCTS_ROW__CELL_COVER,
  PRODUCTION_OBJECTIVE_DROPDOWN__VALIDATE_ICON,
  STOCKS_PRODUCT_ENTITY__LABEL,
  PRODUCTION_OBJECTIVE_DROPDOWN__INPUT,
  STOCKS_PRODUCTS_ROW__SELECT_ICON,
  STOCKS_TABLE__SELECTED_HEADER,
  STOCKS_PRODUCTS_ROW__CELL_COVER_TOOLTIP,
  STOCKS_PRODUCTS_ROW__VIEW_DETAILS_ICON,
  STOCKS_PRODUCT_ENTITY_PRODUCTION_PLAN_TABLE__OBJECTIVE_INPUT_PREFIX,
  STOCKS_PRODUCT_ENTITY_PRODUCTION_PLAN_TABLE__STOCK_PREFIX,
  STOCKS_PRODUCTS_ROW__SECTOR_REDIRECT,
  SECTOR_BREADCRUMBS__CONTAINER,
  STOCKS_PRODUCT_ENTITY__MACHINE_LINK,
  LOAD_TABLE_ROW__EXPAND_ICON,
  LOAD_TABLE_ROW__TOTAL_LOAD_CELL_VALUE,
  STOCKS_PRODUCTS__TITLE,
  CAPA_IMPORT_MODAL__PLANNING_SIMULATION_SELECT,
  CAPA_IMPORT_MODAL__SCHEDULING_SIMULATION_SELECT,
  CAPA_IMPORT_MODAL__UPDATE_MODE_PREFIX,
  FORM_SIMULATIONS_SELECT__DROPDOWN,
  LOAD_TO_CAPACITY_BALANCE_DIALOG__ACTIVATOR,
  LOAD_TO_CAPACITY_BALANCE_DIALOG__CONFIRM_BUTTON,
  SECTOR_CARD__STOCKS_REDIRECT,
  STOCKS_PRODUCTS_ROW__CELL_PREFIX,
};
